import { useEffect } from "react";
import styles from "./overview-tab.module.css";
import { OverviewSummaryCards } from "./components/overview-summary-cards/overview-summary-cards.tsx";
import { TimeBreakdownCards } from "./components/time-breakdown-cards/time-breakdown-cards.tsx";
import { ProjectAllocationCards } from "./components/project-allocation-cards/project-allocation-cards.tsx";
import { useTimesheetStats } from "../../hooks/use-timesheet-stats.ts";
import PageShell from "../../../../shared/page-shell/page-shell.tsx";

interface OverviewTabProps {
  active?: boolean;
}

const OverviewTab = ({ active }: OverviewTabProps) => {
  const { data, loading, refetch } = useTimesheetStats({ type: 'MONTHLY' });

  useEffect(() => {
    if (active) refetch();
  }, [active, refetch]);

  if (loading) {
    return <div className={styles.loading}>Loading overview data...</div>;
  }

  return (
    <PageShell>

      <OverviewSummaryCards
        totalTime={data?.totalTime || "00:00"}
        targetHours={data?.targetHours || 0}
        projectCount={data?.projectOverview?.length || 0}
        utilization={data?.utilization || 0}
      />
      <TimeBreakdownCards
        breakdowns={data?.timeBreakdown || []}
      />
      <ProjectAllocationCards
        projects={data?.projectOverview || []}
      />

    </PageShell>
  );
};

export default OverviewTab;
